exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-container[data-v-72634458] {\n  overflow-y: hidden;\n  overflow-x: scroll;\n  height: 0;\n}", ""]);

// exports
